module.exports = __webpack_public_path__ + "images/profile-artist.png?78d99";